import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Button,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  clearCollectionsList,
  clearCollectionFilters,
  deleteSelectedCollectionFilter,
  setCollectionFilters,
  refreshCollections,
} from '../../actions/Collections';
import {
  deleteSelectedFilter,
  clearFilesFiltersAndReload,
  fetchFiles,
  setFilesFilters,
  setFilesParams,
} from '../../actions/Files';
import { setSearchTerm } from '../../actions/Search';

import FilterBubbles from '../Filters/FilterBubbles';
import PinnedSearchesTags from '../Search/PinnedSearchesTags';
import PinnedSearchesIcons from '../Search/PinnedSearchesIcons';
import PinCreateSmartCollection from '../Search/PinCreateSmartCollection';

import { showModal } from '../../actions';
import { isMini } from '../../helpers/App';
import { getDefaultSortParams } from '../../helpers/Sort';
import {
  filterParams,
  handleURLParamsClear,
  handleURLParamsRemove,
  searchFilterParams,
} from '../../helpers/URLParams';

const FilesFilters = ({
  selectedFilters,
  filesTotal,
  removeFilter,
  clearFilters,
  openExportModal,
  history,
}) => {
  const intl = useIntl();

  const removeFilterWrapper = (type, key) => {
    handleURLParamsRemove(type, key, history);
    removeFilter(type, key);
  };

  const clearFiltersWrapper = (hasSearch) => {
    handleURLParamsClear([...filterParams, ...searchFilterParams], history);
    clearFilters(hasSearch);
  };

  if (selectedFilters.length === 0) {
    return null;
  }

  const hasSearch = selectedFilters.filter(sf => (sf.type === 'search')).length > 0;

  const fSelectedFilters = selectedFilters.filter(sf => (sf.type !== 'search_fields'));

  return (
    <div className="active-filters tags-list">
      <span>
        {!isMini() && (
          <>
            <PinCreateSmartCollection
              selectedFilters={fSelectedFilters}
              type="files"
            />
            <PinnedSearchesTags
              selectedFilters={fSelectedFilters}
              clearFilters={() => clearFiltersWrapper(hasSearch)}
              type="files"
            />
          </>
        )}
        <FilterBubbles
          filters={fSelectedFilters}
          onRemoveFilter={removeFilterWrapper}
        />
        <PinnedSearchesIcons
          selectedFilters={fSelectedFilters}
          type="files"
        />
        <Button color="link" size="sm" onClick={() => { clearFiltersWrapper(hasSearch); }}>
          {intl.formatMessage({ defaultMessage: 'Clear all' })}
        </Button>
      </span>
      {filesTotal > 0 && (
        <span>
          <Button id="export-csv-button" color="link" size="sm" onClick={() => { openExportModal(); }}>
            <i className="far fa-file-export mr-0" />
          </Button>
          <UncontrolledTooltip target="export-csv-button">
            {intl.formatMessage({ defaultMessage: 'Export CSV' })}
          </UncontrolledTooltip>
        </span>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  selectedFilters: state.Files.selectedFilters,
  filesTotal: state.Files.filesTotal,
});

const mapDispatchToProps = dispatch => ({
  removeFilter: (filterType, filterKey) => {
    dispatch(deleteSelectedFilter(filterType, filterKey));
    dispatch(deleteSelectedCollectionFilter(filterType, filterKey));
    if (filterType === 'search') {
      dispatch(setFilesFilters({ search: null }));
      dispatch(setCollectionFilters({ search: null }));
      dispatch(setSearchTerm(''));
      const sortParams = getDefaultSortParams('files', 'created_at', 'desc');
      dispatch(setFilesParams({
        orderby: sortParams.orderby,
        order: sortParams.order,
      }));
    }
    dispatch(fetchFiles());
  },
  clearFilters: (hasSearch) => {
    if (hasSearch) {
      dispatch(setSearchTerm(''));
    }
    dispatch(clearCollectionsList());
    dispatch(clearCollectionFilters());
    dispatch(refreshCollections());
    dispatch(clearFilesFiltersAndReload(hasSearch));
  },
  openExportModal: () => {
    dispatch(showModal('ExportModal', {
      className: 'modal-export',
    }));
  },
});

FilesFilters.propTypes = {
  selectedFilters: PropTypes.array.isRequired,
  filesTotal: PropTypes.number.isRequired,
  removeFilter: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  openExportModal: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FilesFilters));
